import { LocaleKey } from 'helpers/languages/translations';
import { IVisibleKeyword, IVisibleProductKeywordByProduct } from 'types';

export const KEYWORD_FIELDS_BY_PRODUCT: { id: keyof IVisibleProductKeywordByProduct; name: LocaleKey | LocaleKey }[] = [
    { id: 'keywords', name: 'product_keyword.column.kewyords' },
];

export const EMPTY_PRODUCT_KEYWORDS: IVisibleProductKeywordByProduct = {
    ean: '',
    keywords: [],
};

export const EMPTY_PARTIAL_KEYWORD: IVisibleKeyword = {
    name: '',
    language: '',
    keyword_type: '',
    priority: 1,
    master: 1,
};

export const KEYWORD_COLUMN_LIMIT = 5;
